import React from 'react'

// Icons
import { ReactComponent as Cross } from 'icons/cross-16.svg'

// Styles
import {
  Wrapper,
  Title,
  Description,
  IconContainer,
  ActionContainer,
  Dismiss,
  Action,
} from './BannerCard.styles'

// Types
export interface BannerCardProps {
  id: string
  title: string
  description: string
  icon: React.ReactElement
  action?: React.ReactElement
  small?: boolean
  onDismiss?: (id: string) => void
  isDismissable?: boolean
}

/**
 * BannerCard renders a card like Banner
 * with some information, action and is possibly dismissable
 */
const BannerCard: React.FC<BannerCardProps> = ({
  title,
  description,
  icon,
  action,
  small,
  onDismiss,
  id,
}) => {
  return (
    <Wrapper small={small}>
      <IconContainer small={small}>{icon}</IconContainer>
      <div>
        <Title small={small}>{title}</Title>
        <Description small={small}>{description}</Description>
        {!small && (
          <ActionContainer small={small}>
            <Action small={small}>{action}</Action>
            {onDismiss && (
              <Dismiss
                data-testid="dismiss-button"
                onClick={() => onDismiss(id)}>
                <Cross width="14px" height="14px" />
              </Dismiss>
            )}
          </ActionContainer>
        )}
      </div>
      {small && (
        <ActionContainer small={small}>
          <Action small={small}>{action}</Action>
          {onDismiss && (
            <Dismiss
              data-testid="dismiss-button"
              onClick={() => onDismiss(id)}
              small={small}>
              <Cross width="14px" height="14px" />
            </Dismiss>
          )}
        </ActionContainer>
      )}
    </Wrapper>
  )
}

export default BannerCard
